import { render } from "./RenewOffer.vue?vue&type=template&id=2b665efa"
import script from "./RenewOffer.vue?vue&type=script&lang=js"
export * from "./RenewOffer.vue?vue&type=script&lang=js"
script.render = render

export default script